/**
* Slider with Icon Buttons JS
* -----------------------------------------------------------------------------
*
* All the JS for the Slider with Icon Buttons component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'slider-with-icon-buttons',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      // $( '.icon-nav-for-slides' ).slick( {
      //   slidesToShow: 3,
      //   dots: false,
      //   arrows: false,
      //   asNavFor: $( '.primary-slider' ),
      // } );
      $( '.primary-slider' ).slick( {
        infinite: true,
        slidesToShow: 1,
        dots: true,
        focusOnSelect: true,
        arrows: false,
      } );
      $( 'a[data-slide]' ).on( 'click', function( e ) {
        e.preventDefault();
        const slideno = $( this ).data( 'slide' );
        $( '.primary-slider' ).slick( 'slickGoTo', slideno );
        console.log( slideno );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'slider-with-icon-buttons', COMPONENT );
} )( app );
